<script lang="ts">
    import { beforeUpdate, onMount } from 'svelte';
    import Line from '../components/Line.svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import TileMember from '../components/TileMember.svelte';
    import { storeEnterprises, storeEnterpriseId } from "../scripts/enterprise";
    import { storeUsers, storeUsersError } from "../scripts/user";
    import { launchLoader, stopLoader } from "../scripts/utils";
    import { getActiveMembers } from '../scripts/apiUsers';
    import { addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr } from "../scripts/store";

    let enterprise;
    let users;

    beforeUpdate(() => {
        getUsersIfEmpty();
        filterEnterprise($storeEnterpriseId);
        filterUsersByEnterprise($storeEnterpriseId);
    })

    onMount(async () => {
        window.scrollTo(0,0);
	});

    /**
     * filterEnterprise
     * @param id
     */
    function filterEnterprise(id: number) {
        enterprise = $storeEnterprises.filter((element) => element.id == id)[0];
        users = enterprise.members;
    }

    /**
     * filterUsersByEnterprise
     * @param id
     */
    function filterUsersByEnterprise(id: number) {
        users = $storeUsers.filter((element) => element.enterprise == id);
    }

    /**
     * getUsersIfEmpty
     */
     function getUsersIfEmpty() {
        if ($storeUsers.length <= 0) {
            launchLoader();
            const returnValue = getActiveMembers();
            returnValue.then((data) => {
                stopLoader();
                if (!data) {
                    addNotificationError($storeUsersError);
                };
            });
        }
    }

</script>
    
<style lang="scss">

    .entreprise {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__resume {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 32px 32px 64px 32px;
            &__img {
                width: 100%;
            }
        }
        &__members {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 64px 32px 0 32px;
        }
    }

    @include large {
        .entreprise {
            &__resume {
                z-index: 1000;
                &__imglink {
                    width: 100%;
                    max-width: 300px;
                    cursor: pointer;
                    transition: all 0.5s;
                    &:hover {
                        transform: scale(0.8);
                    }
                }
                &__img {
                    width: 100%;
                    max-width: 300px;
                }
            }
        }
    }

</style>

<div class="entreprise">
    <PageHeader props={enterprise.name}/>
    <div class="bloc entreprise__bloc">
        <div class="entreprise__resume">
            {#if (enterprise.url != undefined && enterprise.url != "")}
            <a href={enterprise.url} target="_blank">
                <img class="entreprise__resume__imglink" title={enterprise.url} alt={enterprise.url} src="../assets/images/enterprises/{enterprise.id}_{enterprise.logo}">
            </a>
            {:else}
            <img class="entreprise__resume__img" title={enterprise.name} alt={enterprise.name} src="../assets/images/enterprises/{enterprise.id}_{enterprise.logo}">
            {/if}
            {#if ($storeLanguage == $lang_fr)}
            <span class="font__h3">{enterprise.description_fr}</span>
            {:else}
            <span class="font__h3">{enterprise.description_en}</span>
            {/if}
        </div>
        {#if (users.length > 0)}
        <Line />
        <div class="entreprise__members">
            {#each users as member}
            <TileMember propsDisplayEnterprise={false} propsUser={member} />
            {/each}
        </div>
        {/if}
    </div>
</div>
